import { memo, useCallback } from "react";
import { RangeSlider } from "ui/components/RangeSlider";
import { useTranslate } from "helpers";
import { CalculationPeriodFormProps } from "./types";
import {
  CALCULATION_RENT_MONTHS_MIN,
  CALCULATION_RENT_MONTHS_MAX,
  CALCULATION_RENT_MONTHS_STEP,
  CALCULATION_RENT_KM_MIN,
  CALCULATION_RENT_KM_MAX,
  CALCULATION_RENT_KM_STEP,
} from "services/api/calculations/consts";

const CalculationPeriodForm: React.FC<CalculationPeriodFormProps> = (props) => {
  const { formValues, setFormValues, errors } = props;
  const { t } = useTranslate();

  const handleRangeChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
      const value = Number(e.target.value);
      setFormValues((prev) => ({ ...prev, [name]: value }));
    },
    []
  );

  return (
    <div className="flex items-center justify-center px-4 h-full">
      <div className="w-full max-w-xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
          {t("admin.calculation.create.period.title")}
        </h1>
        <p className="text-center text-md text-slate-600 mb-10">
          {t("admin.calculation.create.period.description")}
        </p>
        <div className="bg-white border border-[#EAECF0] px-6 py-8 rounded-md">
          <div className="uppercase font-bold text-xs mb-2">
            {t("admin.calculation.create.filter.period")}{" "}
            <span className="lowercase opacity-60">
              ({t("admin.calculation.create.filter.period.inmonths")})
            </span>
          </div>
          <RangeSlider
            label=""
            name="rentMonths"
            onChange={handleRangeChange}
            min={CALCULATION_RENT_MONTHS_MIN}
            max={CALCULATION_RENT_MONTHS_MAX}
            step={CALCULATION_RENT_MONTHS_STEP}
            value={formValues.rentMonths}
            unit="mj."
          />
          {errors.rentMonths && (
            <p className="text-xs text-red-500 mt-1">{errors.rentMonths}</p>
          )}

          <div className="uppercase font-bold text-xs mt-12">
            {t("admin.calculation.create.filter.kilometers")}{" "}
            <span className="lowercase opacity-60">
              ({t("admin.calculation.create.filter.kilometers.inyear")})
            </span>
          </div>
          <RangeSlider
            label=""
            name="rentKm"
            onChange={handleRangeChange}
            min={CALCULATION_RENT_KM_MIN}
            max={CALCULATION_RENT_KM_MAX}
            step={CALCULATION_RENT_KM_STEP}
            value={formValues.rentKm}
            formatAsDecimal={true}
            unit="km"
          />
          {errors.rentKm && (
            <p className="text-xs text-red-500 mt-1">{errors.rentKm}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(CalculationPeriodForm);
